import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// import { fShortenNumber } from 'src/utils/format-number';

// ----------------------------------------------------------------------

export default function AppWidgetSummary2({ title, total, icon, color = 'primary', sx, suffix,...other }) {
  return (
    <Card
      component={Stack}
      spacing={2}
      direction="row"
      sx={{
        px: 1,
        py: 1,
        borderRadius: 2,
        color: '#333333',
        ...sx,
      }}
      {...other}
    >
      <Stack alignItems="center" justifyContent="center" sx={{ height: '100%' }}>
        {icon && (
          <Box sx={{ width: 64, height: 64, display: 'flex' }} alignItems="center" justifyContent="center">
            {icon}
          </Box>
        )}
      </Stack>

      <Stack spacing={0.5}>
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography variant="h4" sx={{ color: '#333333' }}>
            {total || 0}
          </Typography>
          {suffix && (
            <Typography variant="body" sx={{ color: 'gray', fontWeight: '400', fontSize: '0.8rem' }}>
              / {suffix}
            </Typography>
          )}
        </Stack>
        <Typography variant="subtitle2" sx={{ color: '#333333' }}>
          {title}
        </Typography>
      </Stack>
    </Card>
  );
}

AppWidgetSummary2.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  sx: PropTypes.object,
  title: PropTypes.string,
  total: PropTypes.number,
};
